module.exports = __webpack_public_path__ + "static/media/bg.2941184d.png";